import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import DemandForecastsController from "@/modules/demandForecasts/DemandForecastsController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function Forecast() {
  const canViewDemandForecasts = useHasPermission(
    Permission.DEMANDFORECAST_VIEW,
  );

  if (!canViewDemandForecasts) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Forecast", current: true }]}
        message="You do not have permission to view demand forecasts."
      />
    );
  }

  return (
    <Layout
      breadcrumbs={[{ label: "Forecast", current: true }]}
      className="overflow-x-hidden"
    >
      <div className="w-full min-w-0 max-w-full overflow-x-hidden">
        <DemandForecastsController />
      </div>
    </Layout>
  );
}
